import {ReactElement} from "react";

import {cn} from "@/lib/utils";

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): ReactElement {
  return <div className={cn("rounded-md skeleton-bg", className)} {...props} />;
}

export {Skeleton};
